










































































import {Component, Emit, PropSync} from "vue-property-decorator";
import moment from 'moment';
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {PickingListCostStatus} from "@/enums/status";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {PickingListCost} from "@/interfaces/entity/pickinglistcost";
import {PickingListCostStore} from "@/modules/pickinglistcost";
import {ExpensePaymentType} from "@/enums/type";
import PLCostStatusLabel from "@/modules/pickinglistcost/components/PickingListCostStatusLabel/index.vue";

@Component({
    name: "PLCostTable",
    components: {PLCostStatusLabel, TooltipLabel}
})
export default class extends mixins(CommonMixin) {
    @PropSync("dataSource", {required: true}) syncDataSource!: Array<PickingListCost>;
    moment = moment;
    PickingListCostStatus = PickingListCostStatus;
    ExpensePaymentType = ExpensePaymentType;
    columns = [
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: "action"},
            width: 140,
        },
        {
            title: "Ngày tạo",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "createdDate"}
        },
        {
            title: "Mã bảng kê",
            dataIndex: "code",
            key: "code",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "code"}
        },
        {
            title: "Nhân viên tạo",
            dataIndex: "createdBy",
            key: "createdBy",
            scopedSlots: {customRender: "createdBy"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Nhân viên nhận",
            dataIndex: "employee",
            key: "employee",
            scopedSlots: {customRender: "employee"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Tổng đơn",
            dataIndex: "ladingQuantity",
            key: "ladingQuantity",
            width: 100
        },
        {
            title: "Tổng số tiền",
            dataIndex: "totalMoney",
            key: "totalMoney",
            scopedSlots: {customRender: "totalMoney"},
            width: 120,
            ellipsis: true
        },
        {
            title: "Hình thức trả",
            dataIndex: "paymentType",
            key: "paymentType",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'paymentType'}
        },
        {
            title: "Số tài khoản",
            dataIndex: "bankAccount",
            key: "bankAccount",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'bankAccount'}
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 150,
            ellipsis: true
        }
    ];

    get pagination(): object {
        return {
            current: PickingListCostStore.meta?.page,
            pageSize: PickingListCostStore.meta?.limit,
            total: PickingListCostStore.meta?.total,
            showTotal: (total: number) => `Tổng cộng ${total} bảng kê`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    @Emit("onChangePage")
    onChangePage(pagination: any) {
        return pagination;
    }

    @Emit("see-detail")
    seeDetail(id: number) {
        return id;
    }

    @Emit("print")
    print(id: number) {
        return id;
    }

    @Emit('delete')
    deletePickingListCost(id: number) {
        return id;
    }

    @Emit('confirm')
    confirmPickingListCost(id: number) {
        return id;
    }

    canDeletePickingListCost(pickingListCost: PickingListCost): boolean {
        return pickingListCost.status === PickingListCostStatus.NotYetPay;
    }
}
